import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "reactstrap";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Drawer,
  Card,
  Modal,
  Select,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  SendOutlined,
} from "@ant-design/icons";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import {
  insertBot,
  updateBot,
  deleteBot,
  getAllBot,
  sendMessage,
  getAllGroups,
} from "../../helpers/helper";
import DataTable from "../../Components/Common/DataTable";
import ModalFunction from "./component/ModalFunction";
import { useUserDetails } from "../../context/UserDetailContext";

const { confirm } = Modal;
const { Option } = Select;
const Roles = () => {
  const { t } = useTranslation();
  document.title = t("botManager");

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [listBot, setListBot] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [dataGroup, setDataGroup] = useState();
  const [isModalFunction, setIsModalFunction] = useState(false);
  const editorContentRef = useRef("");
  const nameRefId = useRef("common");
  const [content, setContent] = useState(null);
  const [typeMessage, setTypeMessage] = useState(1);
  const [listGroup, setListGroup] = useState();
  const { userDetails } = useUserDetails();

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [pageIndex, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchData();
    fetchDataGroup();
  }, []);

  const fetchDataGroup = async () => {
    const res = await getAllGroups();

    if (res) {
      setListGroup(res);
    }
  };

  async function fetchData() {
    try {
      const data = await getAllData();
      setListBot(data);
    } catch (error) {
      message.error(t("requiredPermission"));
    }
  }

  const getRoleFromSessionStorage = () => {
    if (userDetails && userDetails.role) {
      return userDetails.role;
    } else {
      return null;
    }
  };

  const role = getRoleFromSessionStorage();

  const getAllData = async (_prams) => {
    setLoading(true);
    try {
      const params = _prams ? _prams : { pageIndex: 1, pageSize: 10 };
      const dataRes = await getAllBot(params);
      setTotalPage(dataRes?.data.totalPages * pageSize);
      let data = convertDataTable(dataRes.data.data);
      setLoading(false);
      return data.length ? data : false;
    } catch (error) {
      setLoading(false);
      setTotalPage(0);
      message.error(t("requiredPermission"));
    }
  };

  const convertDataTable = (dataArray) => {
    function attendanceTime(time) {
      if (!time) return null;
      if (moment().day() === moment(time).day()) {
        const momentTz = moment(new Date(time)).tz("Asia/Ho_Chi_Minh");
        return momentTz.format("HH:mm");
      }
    }

    let data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        const { attendance1, attendance2 } = item;

        return {
          key: item._id,
          name: item.name,
          attendance1: attendanceTime(attendance1),
          attendance2: attendanceTime(attendance2),
          groupId: item.groupId,
          botToken: item.botToken,
          groupInCompany: item.group,
          createdTime: moment(new Date(item.createdTime)).format(
            "hh:mm DD/MM/YYYY"
          ),
        };
      });
    return dataArray ? data : [];
  };

  const showModelSendMessage = (id) => {
    const dataEdit = listBot.filter((item) => item.key === id);
    setDataGroup(dataEdit[0]);
    setIsModalFunction(true);
  };

  const columns = [
    {
      title: t("GroupNameTelegram"),
      dataIndex: "name",
    },
    {
      title: t("GroupIdTelegram"),
      dataIndex: "groupId",
    },
    {
      title: t("shiftAttendance1"),
      dataIndex: "attendance1",
    },
    {
      title: t("shiftAttendance2"),
      dataIndex: "attendance2",
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) => (
        <Space>
          {role && role.roleName === "SuperAdmin" && (
            <>
              <Tooltip title={t("edit")}>
                <Button
                  type="primary"
                  shape="circle"
                  icon={<EditOutlined />}
                  size="small"
                  onClick={() => onEdit(record.key)}
                />
              </Tooltip>
              <Tooltip title={t("delete")}>
                <Button
                  type="danger"
                  shape="circle"
                  icon={<DeleteOutlined />}
                  size="small"
                  onClick={() => showModalConfirmDelete(record.key)}
                />
              </Tooltip>
            </>
          )}

          <Tooltip title={t("sendMess")}>
            <Button
              type="primary"
              shape="circle"
              icon={<SendOutlined />}
              size="small"
              onClick={() => showModelSendMessage(record.key)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  const onFinish = async (data) => {
    const dataReq = {
      groupId: data.groupId.trim(),
      botToken: data.botToken.trim(),
      name: data.name ? data.name.trim() : "",
      groupInCompany: data.groupInCompany,
    };
    try {
      if (!data.id) {
        const dataRes = await insertBot(dataReq);
        if (dataRes.status === "success") {
          message.success(t("saveSuccess"));
        } else {
          message.error(t("saveFail"));
        }
        formSearch.resetFields();
        fetchData();
      } else {
        const dataRes = await updateBot(data.id, dataReq);
        if (dataRes.status === "success") {
          message.success(t("updateSuccess"));
        } else {
          message.error(t("updateFail"));
        }
      }
      form.resetFields();
      fetchData();
      onClose();
    } catch (error) {
      console.log(error);
      // if (error.response.status === 400) {
      //   return message.error("Sai thông tin bot token hoặc group !");
      // }
      message.error(t("permisstionDeniedAction"));
      formSearch.resetFields();
      form.resetFields();
      onClose();
    }
  };

  const onClose = () => {
    setDrawerTitle("");
    setVisibleForm(false);
    form.resetFields();
  };

  const showDrawer = () => {
    setVisibleForm(true);
  };

  const handleNewBot = () => {
    setDrawerTitle(t("createBot"));
    showDrawer();
    form.resetFields();
  };

  const showModalConfirmDelete = (record) => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete(record);
      },
      onCancel() {},
    });
  };

  const onDelete = async (key) => {
    try {
      const dataRes = await deleteBot(key);
      if (dataRes.status === "success") {
        message.success(t("deleteSuccess"));
        fetchData();
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }
  };

  const onEdit = (key) => {
    const dataEdit = listBot.filter((item) => item.key === key);
    const dataGroup = listGroup.filter(
      (item) => item._id === dataEdit[0].groupInCompany
    );

    form.setFieldsValue({
      groupId: dataEdit[0].groupId,
      name: dataEdit[0].name,
      botToken: dataEdit[0].botToken,
      id: dataEdit[0].key,
      groupInCompany: dataGroup.length ? dataGroup[0]._id : undefined,
    });
    setDrawerTitle(t("editBot"));
    showDrawer();
  };

  const onPageChange = async (page, pageSize) => {
    const dataForm = formSearch.getFieldsValue();
    const params = {
      pageIndex: page,
      pageSize: pageSize,
      name: dataForm.name || "",
    };
    const dataRes = await getAllData(params);
    setListBot(dataRes.length > 0 ? dataRes : false);
    setPageIndex(page);
    setPageSize(pageSize);
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();

    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      name: dataForm.name || "",
    };
    const dataRes = await getAllData(params);
    setListBot(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const handleRefresh = async () => {
    formSearch.resetFields();
    setPageIndex(1);
    setPageSize(10);

    const _params = {
      pageIndex: pageIndex,
      pageSize: pageSize,
    };
    const dataRes = await getAllData(_params);
    setListBot(dataRes);
  };

  const handleSendMessage = async (data) => {
    data.messageId = data?.messageId ? data.messageId : "";
    data.msgContent = data?.msgContent ? data.msgContent : "";

    if (data.msgContent !== "") {
      data.msgContent = data.msgContent
        .replace(/<p>/g, "")
        .replace(/<\/p>/g, "")
        .replace(/"/g, "'")
        .replace(/<br>/g, " \n ");
    }

    try {
      const dataRes = await sendMessage(data);
      if (dataRes.status === "success") {
        message.success(t("sendMessSuccess"));
      } else {
        message.error(t("sendMessFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }

    formEdit.setFieldsValue({
      typeMessage: 1,
      msgContent: "",
    });
    setTypeMessage(1);
    setContent("");
    editorContentRef.current = "";
    setIsModalFunction(false);
  };

  return (
    <>
      <div className="page-content">
        <Card bordered={false}>
          <Row>
            <Col xs={12}>
              <Form form={formSearch} layout="vertical" autoComplete="off">
                <Row>
                  <Col sm={3}>
                    <Form.Item name="name" label={t("GroupNameTelegram") + ":"}>
                      <Input
                        placeholder={t("placeHolderGroupNameBot")}
                        allowClear={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={3}>
                    <Form.Item className="mt-4">
                      <Space>
                        <Button
                          type="primary"
                          htmlType="button"
                          disabled={loading}
                          onClick={() => handleSearch()}
                        >
                          {t("search")}
                        </Button>
                        {role && role.roleName === "SuperAdmin" && (
                          <Button type="primary" onClick={handleNewBot}>
                            {t("createBot")}
                          </Button>
                        )}

                        <Button
                          type="primary"
                          htmlType="button"
                          disabled={loading}
                          onClick={() => handleRefresh()}
                        >
                          {t("reload")}
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <div>
          <Col>
            <Drawer
              title={drawerTitle}
              placement={"right"}
              width="50%"
              onClose={onClose}
              open={visibleForm}
              bodyStyle={{
                paddingBottom: 80,
              }}
              style={{ marginTop: "70px" }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Row>
                  <Col hidden={true}>
                    <Form.Item name="id" label="Id">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Form.Item
                    name="name"
                    label={t("GroupNameTelegram")}
                    rules={[
                      {
                        required: true,
                        message: t("validateGroupNameBot"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("placeHolderGroupNameBot")}
                      allowClear={true}
                    />
                  </Form.Item>
                  <Form.Item
                    name="groupId"
                    label="Id group"
                    rules={[
                      {
                        required: true,
                        message: t("validateGroupNameBot"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("placeHolderGroupNameBot")}
                      allowClear={true}
                    />
                  </Form.Item>
                  <Form.Item
                    name="botToken"
                    label={t("botToken")}
                    rules={[
                      {
                        required: true,
                        message: t("validateBotToken"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("validateBotToken")}
                      allowClear={true}
                    />
                  </Form.Item>
                  <Form.Item
                    name="groupInCompany"
                    label={t("group")}
                    rules={[
                      {
                        required: true,
                        message: t("validateSelectGroup"),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("placeHolderSelectGroup")}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      allowClear
                      showSearch
                    >
                      {listGroup?.length > 0 &&
                        listGroup?.map((item) => {
                          return (
                            <Option key={item._id} value={item._id}>
                              {item.groupName}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Row>

                <Form.Item className="mt-3">
                  <Space>
                    <Button type="primary" htmlType="submit">
                      {t("save")}
                    </Button>

                    <Button type="danger" onClick={onClose}>
                      {t("close")}
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Drawer>
          </Col>
        </div>
        <DataTable
          listData={listBot}
          pageSize={pageSize}
          columns={columns}
          indexPage={pageIndex}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
        />
        <ModalFunction
          dataGroup={dataGroup}
          isModalFunction={isModalFunction}
          setIsModalFunction={setIsModalFunction}
          onFinish={handleSendMessage}
          form={formEdit}
          editorContentRef={editorContentRef}
          nameRefId={nameRefId}
          content={content}
          setContent={setContent}
          setTypeMessage={setTypeMessage}
          typeMessage={typeMessage}
        />
      </div>
    </>
  );
};
export default Roles;
